import './App.css';
import Header from './Components/Header/Header';
import Main from './Components/Main/Main';
import Footer from './Components/Footer/Footer';
import SchemaMarkup from './SchemaMarkup';

function App() {
  return (
    <div className="App">
      <SchemaMarkup />
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
